import React, { Component, Fragment } from "react";
import api from "../../../../../services/api"
import Tabela from "../Tabela"

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            metas: []
        }

    }

    async componentDidMount() {
        await this.consultarMetasMensaisSTI();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.categoriaSelecionada !== this.state.categoriaSelecionada) {
            await this.consultarMetasMensaisSTI();
        }
    }

    consultarMetasMensaisSTI = async () => {
        let metas = await api.get("/sti/metas");
        metas = metas.data.metas;
        let istai = this.soma({ metas, unidade: "ISTAI" })
        let isttc = this.soma({ metas, unidade: "ISTTC" })
        let isteo = this.soma({ metas, unidade: "ISTEO" })
        let total = this.soma({ metas });
        this.setState({ metas, istai, isttc, isteo, total });
    }

    soma = (argumentos) => {
        let { metas, unidade } =  argumentos;
        
        let linha =  [
            "CONSULTORIA EM TECNOLOGIA",
            "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
            "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
            "METROLOGIA",
            "SERVIÇOS COMPLEMENTARES"
        ]

        //let indicadoresnome = ["Número de Atendimento", "Horas Técnicas", "Calibrações", "Ensaios", "Relatórios/Laudos", "Receita", "Despesa"]
        let indicadoresnome = ["numeroAtendimento", "horasTecnicas", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];

        if(["ISTAI", "ISTTC", "ISTEO"].includes(unidade)) {
            //metas = metas.filter(meta => linha.includes(meta.categoria) && meta.unidade === unidade);
            metas = metas.filter(meta => meta.Sigla === unidade);
        }
        else {
            //metas = metas.filter(meta => linha.includes(meta.categoria));
        }

        let soma = {}
        indicadoresnome.forEach(ind => {
            let vetor = Array(12).fill(0);
            soma[ind] = vetor
        });

        metas.map(val => {
            indicadoresnome.map((indicador) => {
                if(val[indicador]) {
                    val[indicador].map((valorMensal, i) => {
                        soma[indicador][i] += valorMensal;
                    });
                }
            });
        });
        return soma;

    }

    render() {
        let indicadoresnome = ["Número de Atendimento", "Horas Técnicas", "Calibrações", "Ensaios", "Relatórios/Laudos"/*, "Receita", "Despesa"*/]
        let { istai, isttc, isteo, total: soma } = this.state;
        return (
            <Fragment>
                <Tabela soma={soma} indicadoresnome={indicadoresnome} unidade={"Total"} />
                {/* <Tabela soma={istai} indicadoresnome={indicadoresnome} unidade={"IST Automação Industrial"} /> */}
                <Tabela soma={isteo} indicadoresnome={indicadoresnome} unidade={"IST Eficiência Operacional"} />
                <Tabela soma={isttc} indicadoresnome={indicadoresnome} unidade={"IST Têxtil e Confecção"} />
            </Fragment>
        )
    }
}